/**
 * Created by yz on 2017/3/22.
 */
{
    angular.module('appModule',['ui.router','interfaceModule','dataModule','utilsModule',
        'ngMd5','angularFileUpload','ngSanitize','datepickerapp'])                 //在这里注入服务。指令
        .controller('appController',function($scope){
            $scope.wait = '';
            $scope.mycss = {
                 "display":"none"
            }
        })
        .config(appConfig);
    angular.module('utilsModule',[]);
    angular.module('interfaceModule',[]);
    angular.module('dataModule',[]);


        appConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$httpProvider'];

        function appConfig($stateProvider, $urlRouterProvider, $httpProvider) {

        //==========以下是路由配置=====Start==============================================================================//
        $stateProvider
        //登录前页面
            .state("login", {
                url: "/login?{openid}",
                views: {
                    "wrapView": {
                        templateUrl: "./app/views/login.html",
                        controller: "LoginController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main", {
                url: "/main",
                abstract:true,
                views: {
                    "wrapView": {
                        templateUrl: "./app/views/main.html",
                        controller: "MainController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.useProcess", {
                url: "/useProcess",
                // abstract:true,
                views: {
                    "contentView": {
                        templateUrl: "./app/views/content/useProcess.html",
                        controller: "UseProcessController",
                        controllerAs: 'vm'
                    }
                }
            })
                .state("main.aboutUs", {
                    url: "/aboutUs",
                    // abstract:true,
                    views: {
                        "contentView": {
                            templateUrl: "./app/views/content/aboutUs.html",
                            controller: "AboutUsController",
                            controllerAs: 'vm'
                        }
                    }
                })
                .state("main.contactUs", {
                    url: "/contactUs",
                    // abstract:true,
                    views: {
                        "contentView@main": {
                            templateUrl: "./app/views/content/contactUs.html",
                            controller: "ContactUsController",
                            controllerAs: 'vm'
                        }
                    }
                })
            .state("main.home", {
                url: "/home",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/home.html",
                        controller: "HomeController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.uploading", {
                url: "/uploading",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/uploading.html",
                        controller: "UploadingController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.printSettings", {
                url: "/printSettings/?{printType}&{orderId}&{canprintagain}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/printSettings.html",
                        controller: "PrintSettingsController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.pay", {
                url: "/pay/?{orderId}&{checkPayResult}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/pay.html",
                        controller: "PayController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.paySuccess", {
                url: "/paySuccess/?{orderId}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/paySuccess.html",
                        controller: "PaySuccessController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.refund", {
                url: "/refund/?{orderId}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/refund.html",
                        controller: "RefundController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.refundDetail", {
                url: "/refundDetail/?{orderId}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/refundDetail.html",
                        controller: "RefundDetailController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.order", {
                url: "/order",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/order.html",
                        controller: "OrderController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.orderDetail", {
                url: "/orderDetail/?{orderId}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/orderDetail.html",
                        controller: "OrderDetailController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.preview", {
                url: "/preview/?{orderId}&{printType}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/preview.html",
                        controller: "PreviewController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.user", {
                url: "/user",
                cache:'false',//缓存
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/user.html",
                        controller: "UserController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.recharge", {
                url: "/recharge/?{userId}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/recharge.html",
                        controller: "RechargeController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.company",{
                url: "/company/?{userId}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/company.html",
                        controller: "CompanyController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.partner",{
                url: "/partner/?{userId}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/partner.html",
                        controller: "PartnerController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.advertising",{
                url: "/advertising",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/modals/advertising.html",
                        controller: "advertisingController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.proclamation",{
                url: "/proclamation",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/proclamation.html",
                        controller: "proclamationController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.machineTip",{
                url: "/machineTip/?{userId}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/machineTip.html",
                        controller: "machineTipController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.uploadImage",{
                url: "/uploadImage",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/uploadImage.html",
                        controller: "uploadImageController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.rechargeRecord",{
                url: "/rechargeRecord/?{userId}",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/rechargeRecord.html",
                        controller: "RechargeRecordController",
                        controllerAs: 'vm'
                    }
                }
            })
            .state("main.stationMap",{
                url:"/stationMap",
                views: {
                    "contentView@main": {
                        templateUrl: "./app/views/content/stationMap.html",
                        controller: "StationMapController",
                        controllerAs: 'vm'
                    }
                }
            });




        $urlRouterProvider.otherwise('login');          //默认跳到这个页面
        //==========路由配置=====End======================================================================================//
    }
}

